function max(x) {
  if (x.length === 0) {
    throw new Error('max requires at least one data point');
  }

  var value = x[0];

  for (var i = 1; i < x.length; i++) {
    if (x[i] > value) {
      value = x[i];
    }
  }

  return value;
}

function min(x) {
  if (x.length === 0) {
    throw new Error('min requires at least one data point');
  }

  var value = x[0];

  for (var i = 1; i < x.length; i++) {
    if (x[i] < value) {
      value = x[i];
    }
  }

  return value;
}

function sum(x) {
  if (x.length === 0) {
    return 0;
  }

  var sumNum = x[0];
  var correction = 0;
  var transition;

  for (var i = 1; i < x.length; i++) {
    transition = sumNum + x[i] * 1;

    if (Math.abs(sumNum) >= Math.abs(x[i])) {
      correction += sumNum - transition + x[i];
    } else {
      correction += x[i] - transition + sumNum;
    }

    sumNum = transition;
  }

  return sumNum + correction * 1;
}

function mean(x) {
  if (x.length === 0) {
    throw new Error('mean requires at least one data point');
  }

  return sum(x) / x.length;
}

export { sum, max, min, mean };
export var statMap = {
  min: min,
  max: max,
  mean: mean,
  sum: sum
};
//# sourceMappingURL=statistics.js.map